import { getTranslation } from "../helpers";

/** A custom element for the valve placement input. */
export class ValvePlacementInput extends HTMLDivElement {
	/** Initializes the element. */
	constructor() {
		super();
		this.style.display = "none";
		this.className = "rt-pspr-input-pair rt-pspr-placement-input";
		this.innerHTML = `
    <label for="rt-psp-custom-placement-input">${getTranslation(
			"placement",
		)}</label>
    <input type="text" id="rt-psp-custom-placement-input" name="properties[Valve Placement]" placeholder="${getTranslation(
			"enter-placement",
		)}">
    `;
	}
}

/** Registers the custom element. */
export function register(): void {
	customElements.define("valve-placement-input", ValvePlacementInput, {
		extends: "div",
	});
}
